var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5769 24.7998H22.8626C22.6921 24.7998 22.5286 24.8688 22.408 24.9915C22.2875 25.1143 22.2197 25.2808 22.2197 25.4544V38.5453C22.2197 38.7189 22.2875 38.8853 22.408 39.0081C22.5286 39.1308 22.6921 39.1998 22.8626 39.1998H39.5769C39.7474 39.1998 39.9109 39.1308 40.0314 39.0081C40.152 38.8853 40.2197 38.7189 40.2197 38.5453V25.4544C40.2197 25.2808 40.152 25.1143 40.0314 24.9915C39.9109 24.8688 39.7474 24.7998 39.5769 24.7998ZM31.6143 33.171C31.5015 33.2603 31.3626 33.3088 31.2197 33.3088C31.0768 33.3088 30.938 33.2603 30.8252 33.171L24.532 28.1875L25.3211 27.1541L31.2197 31.8251L37.1183 27.1541L37.9074 28.1875L31.6143 33.171Z",
    fill: "#CCAA60"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2197,
    cy: 31,
    r: 30,
    stroke: "#CCAA60",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b033021ef8d908abca2bad81c68d66ea.svg";
export { ForwardRef as ReactComponent };